import { render, staticRenderFns } from "./SetupCamerasTable.vue?vue&type=template&id=0fc2b696"
import script from "./SetupCamerasTable.vue?vue&type=script&lang=js"
export * from "./SetupCamerasTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports